import { useMemo } from "react"
import moment from "moment"

export const PERIOD = {
  BEFORE: -2,
  DAY_BEFORE: -1,
  DURING: 0,
  DAY_AFTER: 1,
  AFTER: 2,
}

export function usePeriod(edition) {
  const now = useMemo(() => moment(), [])
  return useMemo(() => {
    const beginDate = moment(edition.beginDate)
    const endDate = moment(edition.endDate)
    if (now.isBefore(beginDate.clone().subtract(8, "hours"))) return PERIOD.BEFORE
    if (now.isBefore(beginDate)) return PERIOD.DAY_BEFORE
    if (now.isBefore(endDate)) return PERIOD.DURING
    if (now.isBefore(endDate.clone().add(11, "hours"))) return PERIOD.DAY_AFTER
    return PERIOD.AFTER
  }, [edition])
}